<template>
  <div class="boxes">
    <h3><Icon type="md-bookmarks" />报警级别分析<slot name="right"></slot></h3>
    <Table :data='tableData' :columns='columns'>
      <template slot-scope="{ row }" slot="alarmLevel">
        <span v-if="row.alarmLevel === 1">一级报警</span>
        <span v-else-if="row.alarmLevel === 2">二级报警</span>
        <span v-else-if="row.alarmLevel === 3">三级报警</span>
      </template>
      <template slot-scope="{ row }" slot="alarmTotal">
        <span>{{ row.alarmTotal }}次</span>
      </template>
      <template slot-scope="{ row }" slot="carTotal">
        <span>{{ row.carTotal }}辆</span>
      </template>
    </Table>
  </div>
</template>
<script>
export default {
  data() {
    return {

      tableData: [],
      columns: [
        {
          title: "报警级别",
          key: "alarmLevel",
          slot: 'alarmLevel',
        },
        {
          title: "报警总数",
          key: "alarmTotal",
          slot: 'alarmTotal',
        },
        {
          title: "报警车辆",
          key: "carTotal",
          slot: 'carTotal',
        },
      ],
    };
  },
  methods: {
    getData(v) {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-car-server-oam/report/countLevel",
        data: v,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.tableData=res.data.data;
      });
    },
  },
  mounted() {
    
  },
};
</script>
<style>

</style>


// WEBPACK FOOTER //
// src/components/dataAnalyse/anaReports/baojingjibie.vue